"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSandboxName = void 0;
const getSandboxName = ({ alias, id, title, }) => title || alias || id;
exports.getSandboxName = getSandboxName;
